// extracted by mini-css-extract-plugin
export default {"BannerParagraph":"BannerParagraph_BannerParagraph__7Qw7F"};